(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["associations"] = factory();
	else
		root["OAJ"] = root["OAJ"] || {}, root["OAJ"]["associations"] = factory();
})(self, () => {
return 